import React from "react";
/* import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css"; */
import maritzLogo from "../assets/maritz-logo.png"; // Save the attached image as src/assets/maritz-logo.png

declare global {
  interface Window {
    OneTrust?: {
      ToggleInfoDisplay(): void;
    };
  }
}

const Footer: React.FC = () => (
  <footer className="as-footer">
    <div>
      <img src={maritzLogo} alt="Maritz Logo" />
    </div>
    <div className="as-footer-links">
      <a
        href="https://cdn.services.mge360.com/docs/maritz-terms-of-use.pdf"
        className=""
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </a>
      <span className="">|</span>
      <a
        href="https://cdn.services.mge360.com/docs/maritz-privacy-policy.pdf"
        className=""
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      <span className="">|</span>
      <button
        type="button"
        className=""
        onClick={() => {
          (window as any).OneTrust?.ToggleInfoDisplay();
        }}
        style={{ background: 'none', border: 'none', padding: 0, color: 'inherit', textDecoration: 'underline', cursor: 'pointer' }}
      >
        Cookie Settings
      </button>
    </div>
    <div className="small text-secondary">Copyright ©2025 Maritz</div>
  </footer>
);

export default Footer;
